export enum EEndpoint {
  USER = 'user/:id',
  WISH_LIST_CATALOGUE = 'wish-list',
  WISH_LIST = 'wish-list/:wishlistId',
  WISH_LIST_SHARE = 'wish-list/share/:wishlistId',
  WISH = 'wish',
  WISH_ID = 'wish/:wishId',
  WISH_BOOKED = 'wish/:wishId/booked',
  WISH_COPY = 'wish/:wishId/copy',
  GROUP_LIST = 'group',
  GROUP = 'group/:groupId',
  GROUP_ID = 'group/:groupId',
  GROUP_RESUME = 'group/:groupId/resume',
  GROUP_MEMBERS = 'group/:groupId/members',
  GROUP_WISHES = 'group/:groupId/wishes',
  GROUP_ADD_WISHES = 'group/:groupId/add-wish',
  GROUP_MONEYBOX = 'group/:groupId/moneybox',
  GROUP_LIKE_WISH = 'group/:groupId/wishes/:wishId/like',
  GROUP_LIKE_AMOUNT = 'amount-poll/:amountId/like',
  GROUP_CHAT = 'group/:groupId/message',
  GROUP_CHAT_LAST = 'group/:groupId/message/last',
  GROUP_USE_MONEYBOX = '/group/:groupId/moneybox/use',
  GROUP_WISH_PURCHASE = '/group/:groupId/wish/purchase',
  GROUP_SENDMAIL = '/group/:groupId/sendmail',
  GET_USERS = 'users/search',
  GET_USER_WISH_LIST_CATALOGUE = 'wish-list/authorized',
  USER_MAIN_PHOTO_UPLOAD = 'users/photo/main',
  GROUP_MAIN_PHOTO_UPLOAD = 'group/:groupId/photo/main',
  WISH_MAIN_PHOTO_UPLOAD = 'wish/:wishId/photo/main',
  WISH_OPTIONAL_PHOTO_UPLOAD = 'wish/:wishId/photo/optional',
  WISH_OPTIONAL_PHOTO_DELETE_MANY = 'wish/:wishId/photo/optional/delete',
  WISH_OPTIONAL_PHOTO_DELETE_ONE = 'wish/:wishId/photo/optional/:photoId',
  WISH_FIND = 'wish/find',
  GET_CURRENT_USER = 'users/current',
  REGISTER_USER = 'users/register',
  SHARE_WISH = 'wish/:wishId/share',
  WISH_LIST_AUTH = 'wish-list/:wishListId/authorized-user',
  REMOVE_WISH_LIST_AUTH = 'wish-list/:wishListId/authorized-user/:userId',
  GET_CONTACTS = 'contact',
  CONTACT_ID = 'contact/:contactId',
  INVITE_CONTACTS = 'contact/invitation',
  EMAIL_VERIFICATION = 'auth0/resend-verification-mail',
  BANK_PAYMENTS_RESUME = 'mybank/transactions',
  BANK_PENDING_PAYMENTS = 'mybank/pending-payment',
  BANK_SOCIAL_PROJECTS = 'mybank/donations',
  LILI_BANK = 'mybank/social-projects',
  GET_TPV_URL = 'payment/request',
  POLICY = 'users/compliance',
  THIRD_PARTY_PAYMENT_SEND_MAIL = 'payment/third-party/:pendingPaymentId',
  THIRD_PARTY_PAYMENT_GET_ID = 'payment/third-party/id',
  SET_AS_PAID = 'payment/external/:pendingPaymentId',
  SET_VARIABLE_AMOUNT = 'payment/variable/:pendingPaymentId',
}

export type TEndpoint =
  | EEndpoint.USER
  | EEndpoint.WISH_LIST_CATALOGUE
  | EEndpoint.WISH_LIST
  | EEndpoint.WISH_LIST_SHARE
  | EEndpoint.WISH
  | EEndpoint.WISH_ID
  | EEndpoint.WISH_BOOKED
  | EEndpoint.WISH_COPY
  | EEndpoint.GROUP_LIST
  | EEndpoint.GROUP
  | EEndpoint.GROUP_ID
  | EEndpoint.GROUP_RESUME
  | EEndpoint.GROUP_MEMBERS
  | EEndpoint.GROUP_WISHES
  | EEndpoint.GROUP_ADD_WISHES
  | EEndpoint.GROUP_MONEYBOX
  | EEndpoint.GROUP_LIKE_WISH
  | EEndpoint.GROUP_LIKE_AMOUNT
  | EEndpoint.GROUP_CHAT
  | EEndpoint.GROUP_CHAT_LAST
  | EEndpoint.GROUP_USE_MONEYBOX
  | EEndpoint.GROUP_WISH_PURCHASE
  | EEndpoint.GROUP_SENDMAIL
  | EEndpoint.GET_USER_WISH_LIST_CATALOGUE
  | EEndpoint.GROUP_MAIN_PHOTO_UPLOAD
  | EEndpoint.USER_MAIN_PHOTO_UPLOAD
  | EEndpoint.WISH_MAIN_PHOTO_UPLOAD
  | EEndpoint.WISH_OPTIONAL_PHOTO_UPLOAD
  | EEndpoint.WISH_OPTIONAL_PHOTO_DELETE_MANY
  | EEndpoint.WISH_OPTIONAL_PHOTO_DELETE_ONE
  | EEndpoint.WISH_FIND
  | EEndpoint.GET_CURRENT_USER
  | EEndpoint.GET_USERS
  | EEndpoint.REGISTER_USER
  | EEndpoint.SHARE_WISH
  | EEndpoint.WISH_LIST_AUTH
  | EEndpoint.REMOVE_WISH_LIST_AUTH
  | EEndpoint.GET_CONTACTS
  | EEndpoint.CONTACT_ID
  | EEndpoint.INVITE_CONTACTS
  | EEndpoint.EMAIL_VERIFICATION
  | EEndpoint.BANK_PAYMENTS_RESUME
  | EEndpoint.BANK_PENDING_PAYMENTS
  | EEndpoint.BANK_SOCIAL_PROJECTS
  | EEndpoint.LILI_BANK
  | EEndpoint.GET_TPV_URL
  | EEndpoint.POLICY
  | EEndpoint.THIRD_PARTY_PAYMENT_SEND_MAIL
  | EEndpoint.THIRD_PARTY_PAYMENT_GET_ID
  | EEndpoint.SET_AS_PAID
  | EEndpoint.SET_VARIABLE_AMOUNT;
